<template>
    <div>
        <template>
            <b-card header-tag="header" footer-tag="footer" class="mt-8">
            <template v-slot:header>
                <p class="mb-0 text-center" style="font-size: 21px">Detalle del pedido #{{datos.id}}</p>
            </template>
            <b-card-text>
                <div><b>Realizado Por:</b> {{datos.nombre_usuario}}</div>
                <div><b>Fecha:</b> {{datos.created_at}}</div>
                <div><b>Nombre Cliente:</b> {{datos.nombre_cliente}}</div>
                <div><b>documento:</b> {{datos.documento_cliente}}</div>
                <div><b>correo:</b> {{datos.correo_cliente}}</div>
                <div><b>Telefono:</b> {{datos.telefono_cliente}}</div>
                <div><b>Dirección:</b> {{datos.direccion_cliente}}</div>
                <div><b>Departamento:</b> {{datos.nombre_departamento_pedido}}</div>
                <div><b>Ciudad:</b> {{datos.nombre_ciudad_pedido}}</div>
                <div v-if="pedidoProveedorId !== null">
                    <b v-if="canOrdersProv">Pedido Proveedor <router-link :to="{name: 'InfoPedidoProveedor', params:{ id: pedidoProveedorId}}">#{{pedidoProveedorId}}</router-link> </b>
                </div>
                <div v-if="datos.guide_pdf_url && checkGuideUploadPermission()">
                    <b>Guía:</b> 
                    <b-button size="sm" variant="primary ml-2" :href="datos.guide_pdf_url" target="_blank">
                        Ver guía <b-icon icon="file-earmark-check"></b-icon>
                    </b-button>
                </div>
            </b-card-text>
            <b-card-text bg-variant="secondary">
                <p class="mb-0 text-center" style="font-size: 21px">Items Del pedido</p>
            </b-card-text>
            <b-card-text>
                <itemsComponent :productos="productos" :datos="datos"/>
            </b-card-text>
            <template v-slot:footer>
                <b-button id="volver" variant="danger" 
                    class="text-white mr-2" 
                    :to="{name: 'ListadoPedidos'}">
                    Volver Listado
                </b-button>
                <template v-if="canOrdersProv && pedidoProveDone && isItemsPropiosOnly === false">
                    <b-button variant="success" 
                        class="text-white mr-2" 
                        v-if="pedidoProveDone && isItemsPropiosOnly === false" 
                        @click.prevent="sendItemsData(productos)">
                        Solicitar Proveedor
                    </b-button>
                </template>
                <b-button variant="info" 
                    class="text-white mr-2" 
                    @click.prevent="printWindow()">
                    Imprimir
                </b-button>
                <a variant="info" 
                    class="text-white btn btn-info mr-2" 
                    :href="urlWebBackend+'download-pedido-cliente-excel/'+datos.id" target="_blank">
                    Exportar csv
                </a>
                <b-button 
                    v-if="datos.guide_pdf_url === null && checkGuideUploadPermission()"
                    variant="info" 
                    class="text-white mr-2" 
                    @click="showUploadModal(datos.id, datos)"
                    v-b-tooltip.hover 
                    title="Subir guía PDF"
                >
                Subir guia
                    <b-icon icon="file-earmark-arrow-up"></b-icon>
                </b-button>
                <b-button v-if="checkOwnOdooPermission()"
                    variant="info" 
                    class="text-white mr-2" 
                    @click="showSendToOdooModal(datos.id, datos)"
                    v-b-tooltip.hover 
                    title="Enviar a Odoo">
                    Enviar a Odoo
                </b-button>
            </template>
        </b-card>
        </template>
        <!-- modal to create order proveedor -->
        <RequestOrderProveedor 
            :datos="datos"
            :itemsProveedor="itemsProveedor" 
            :liquidacionProveedor="liquidacionProveedor" 
            :modalPedidoProveedor="modalPedidoProveedor"
            :itemsNoAvailable="itemsNoAvailable"
            :comentario="comentario"
            :disableProcess="disableProcess"
            :servicioLogistico="servicioLogistico"
            :notLogisticServiceMessage='notLogisticServiceMessage'
            @close-modal="modalPedidoProveedor = false"
            @open-modal-order-comment="modalComment = true"
            @compare-available-amount="compareAvailableAmount($event, itemsProveedor)"
            @remove-item-to-proveedor="removeItemToProveedor($event, itemsProveedor)"
            @store-pedido-proveedor="confirmSendPedido($event, datos)"
            @servicio-logistico-change="servicioLogisticoChange($event, itemsProveedor)"
        />

        <!-- modal to add comment to order -->
        <CommentOrderModal 
            :modalComment="modalComment" 
            @close-modal="modalComment = false"
            @add-comment-to-order="addCommentToOrder($event)"
        />

        <LogisticServicePriceModal
            :itemsProveedor="itemsProveedor"
            :pedidoData="pedidoData"
            :costoFlete="costoFlete"
            :logisticServiceModal="logisticServiceModal"
            @close-modal="logisticServiceModal = false"
            @confirm-pedido="storePedidoProveedor($event, pedidoData)"
        />

        <guide-pdf-upload-modal
            v-if="isPdfModalVisible"
            :modal-visible="isPdfModalVisible"
            :is-loading="isUploading"
            :order-id="currentOrderId"
            :order-data="currentOrderData"
            @close-modal="isPdfModalVisible = false"
            @upload-pdf="handlePdfUpload"
        />

        <send-order-to-odoo-modal
            v-if="isSendToOdooModalVisible"
            :modal-visible="isSendToOdooModalVisible"
            :order-id="currentOrderId"
            :order-data="currentOrderData"
            :odoo-instances="odooIstances"
            @close-modal="isSendToOdooModalVisible = false"
            @send-to-odoo="sendOrderToOdooClient($event)"
        />

    </div>
</template>
<script>
import itemsComponent from '../components/ItemsComponent.vue'
import { mapState, mapMutations } from 'vuex'
import RequestOrderProveedor from '../components/RequestOrderProveedor.vue'
import CommentOrderModal from '../components/CommentOrderModal.vue'
import LogisticServicePriceModal from '../components/LogisticServicePriceModal.vue'
import GuidePdfUploadModal from '../components/GuidePdfUploadModal.vue';
import sendOrderToOdooModal from '../components/sendOrderToOdooModal.vue';

export default {
    computed: {
        ...mapState('configuration', ['urlWebBackend']),
        ...mapState('auth', ['user'])
    },
    data(){
        return{
            errorMessage: "",
            pedidoProveedorId: null,
            datos: {},
            productos: [],
            itemsProveedor: [],
            liquidacionProveedor: {},
            modalPedidoProveedor: false,
            pedidoProveDone: false,
            isItemsPropiosOnly: true,
            canOrdersProv: false,
            id: this.$route.params.id,
            disableProcess: false,
            modalComment: false,
            comentario: null,
            servicioLogistico: false,
            notLogisticServiceMessage: '',
            logisticServiceModal: false,
            costoFlete: 0,
            pedidoData: {},
            itemsNoAvailable: [],
            isPdfModalVisible: false,
            isUploading: false,
            currentOrderId: null,
            currentOrderData: null,
            odooIstances: [],
            isSendToOdooModalVisible: false,
        }
    },
    components: {
        itemsComponent,
        RequestOrderProveedor,
        CommentOrderModal,
        LogisticServicePriceModal,
        GuidePdfUploadModal,
        sendOrderToOdooModal
    },
    created(){
        this.getPedidoinfo();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getPedidoinfo(){
            this.setLoading(true)
            this.userPermissions = localStorage.getItem('user_permissions');
            this.companyPermission = localStorage.getItem('empresa_permissions');
            if(this.userPermissions.includes('can_orders_prov')){
                this.canOrdersProv = true;
            }
            await this.$conectar.post('pedidos/get-pedido-info', {id: this.id})
            .then(response =>{
                this.datos = response.data.pedidoLocal;
                this.productos = response.data.pedidoLocal.items;
                this.pedidoProveedorId = response.data.pedidoLocal.pedido_proveedor_id;
                if(response.data.pedidoLocal.pedido_proveedor_id === null){
                    this.pedidoProveDone = true;
                }
                this.isItemsPropiosOnly = response.data.isItemsPropiosOnly;
                this.odooIstances = response.data.odooInstances;
                
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
            
        },
        addCommentToOrder(comment){
            if(comment){
                this.comentario = comment;
                if (!comment.replace(/\s/g, '').length) {
                    this.comentario = null;
                }
            }else{
                this.comentario = null;
            }
            this.modalComment = false
        },
        removeItemToProveedor(index, itemsProveedor) {
            this.itemsProveedor.splice(index, 1);
            
            if(itemsProveedor.length < 1){
                this.modalPedidoProveedor = false;
            }else{
                this.updateItemCantidad(itemsProveedor);
            }
        },
        compareAvailableAmount(item, itemsProveedor){
            let cantidad = Number(item.cantidad);
            let existencia = Number(item.existencia);
            if(cantidad <= existencia){
                this.updateItemCantidad(itemsProveedor);
            }else{
                this.disableProcess = true;
            }
        }
        ,
        async sendItemsData(productos){
            this.disableProcess = false;
            this.setLoading(true)
            let cantidadReferencia = productos;
            let array = [];
             for (var key in cantidadReferencia) {
                if(cantidadReferencia[key].item_propio === 0){
                    array.push({
                        referencia: cantidadReferencia[key].referencia,
                        cantidad: cantidadReferencia[key].cantidad,
                    })
                }
            }
            await this.$conectar.post('pedidos/proveedor/get-pedido-info-and-price', {codigos: array, servicioLogistico: this.servicioLogistico, pedidoId: this.datos.id})
            .then(response =>{
                if(response.data.noAvailable){
                    this.disableProcess = true;
                }
                 if(response.data.notLogisticService){
                    this.notLogisticServiceMessage = response.data.notLogisticServiceMessage
                    this.disableProcess = true;
                }
                this.itemsNoAvailable = response.data.itemsNoAvailable;
                this.itemsProveedor = response.data.cartItems;
                this.liquidacionProveedor = response.data.cart;
                this.modalPedidoProveedor = true;
                this.costoFlete = response.data.costoFlete;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
            
        },
        async updateItemCantidad(itemsProveedor){
            this.disableProcess = false;
            this.setLoading(true)
            let cantidadReferencia = itemsProveedor;
            let array = [];
             for (var key in cantidadReferencia) {
                array.push({
                    referencia: cantidadReferencia[key].referencia,
                    cantidad: cantidadReferencia[key].cantidad,
                })
            }
            await this.$conectar.post('pedidos/proveedor/get-pedido-info-and-price', {codigos: array, servicioLogistico: this.servicioLogistico, pedidoId: this.datos.id})
            .then(response =>{
                this.itemsProveedor = response.data.cartItems;
                this.liquidacionProveedor = response.data.cart;
                this.modalPedidoProveedor = true;
                this.costoFlete = response.data.costoFlete;
                if(response.data.noAvailable){
                    this.disableProcess = true;
                }
                if(response.data.notLogisticService){
                    this.notLogisticServiceMessage = response.data.notLogisticServiceMessage
                    this.disableProcess = true;
                }
            })
            .catch(e => {
                console.log(e);
                this.modalPedidoProveedor = false;
            })
            this.setLoading(false)
            
        },
        async storePedidoProveedor(itemsProveedor, datos){
            this.setLoading(true)
            this.logisticServiceModal = false;
            let cantidadReferencia = itemsProveedor;
            let array = [];
             for (var key in cantidadReferencia) {
                array.push({
                    referencia: cantidadReferencia[key].referencia,
                    cantidad: cantidadReferencia[key].cantidad,
                })
            }
            let codigos = array;
            let sucursalId = datos.sucursal_id;
            let pedidoId = datos.id;
            let refSucursal = datos.referencia_sucursal;
            let comentario = this.comentario;
            let servicioLogistico = this.servicioLogistico;
            let pedidoData = { codigos, sucursalId, refSucursal, pedidoId, comentario, servicioLogistico}
            await this.$conectar.post('pedidos/proveedor/store-pedido', pedidoData)
            .then(response =>{
                if(response.data.error == true){
                    this.errorMessage = response.data.mensaje;
                    this.$root.$bvToast.toast(response.data.mensaje, {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }else{
                    this.$root.$bvToast.toast('EL pedido fue realizado correctamente', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this.pedidoProveDone = false;
                    let id = response.data.pedidoProveedor.id;
                    this.$router.push({ name: 'InfoPedidoProveedor', params:{ id: id} });
                }
            })
            .catch(e => {
                const status = e.response?.status;
                const message = status === 503
                    ? e.response.data?.message ?? 'Servicio en mantenimiento, intente más tarde.'
                    : 'Error al sincronizar, contactar soporte';

                this.$bvToast.toast(message, {
                    title: status === 503 ? 'Mantenimiento' : 'Error',
                    variant: 'danger',
                    solid: true
                });
            })
            this.modalPedidoProveedor = false;
            this.setLoading(false)
            
        },
        servicioLogisticoChange(servicioLogistico, itemsProveedor){
            this.servicioLogistico = servicioLogistico;
            this.updateItemCantidad(itemsProveedor)
        },
        confirmSendPedido(itemsProveedor, pedidoData){
            if(this.servicioLogistico){
                this.logisticServiceModal = true;
                this.pedidoData = pedidoData;
            }else{
                this.storePedidoProveedor(itemsProveedor, pedidoData)
            }
        },
        printWindow() {
            window.print();
        },
        showUploadModal(orderId, rawOrderData) {
            const formattedOrderData = {
                customer: rawOrderData.nombre_cliente || '',
                date: rawOrderData.created_at || '',
                // Puedes agregar más campos según sea necesario
            };

            this.currentOrderId = orderId;
            this.currentOrderData = formattedOrderData;
            this.isPdfModalVisible = true;
        },
        showSendToOdooModal(orderId, rawOrderData) {
            const formattedOrderData = {
                customer: rawOrderData.nombre_cliente || '',
                date: rawOrderData.created_at || '',
                // Puedes agregar más campos según sea necesario
            };

            this.currentOrderId = orderId;
            this.currentOrderData = formattedOrderData;
            this.isSendToOdooModalVisible = true;
        },
        async handlePdfUpload(formData) {
            this.isUploading = true;
            try {
                const response = await this.$conectar.post('pedidos/upload-guide-pdf', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                
                if (response.data.error === false) {
                    this.$bvToast.toast(response.data.message, {
                        title: "PDF cargado exitosamente",
                        variant: "success",
                        solid: true
                    });
                    
                    // Cerrar el modal después de subir exitosamente
                    this.isPdfModalVisible = false;
                    
                    // Opcional: actualizar datos o refrescar la lista de órdenes
                    this.getPedidoinfo(); // Asume que tienes un método para esto
                } else {
                    this.$bvToast.toast(response.data.message, {
                        title: "Error al cargar el PDF",
                        variant: "danger",
                        solid: true
                    });
                }
            } catch (e) {
                console.log(e.response);
                
                let errorMessage = "Parece que hubo un error al conectar con el servidor";
                
                if (e.response && e.response.data && e.response.data.message) {
                    errorMessage = e.response.data.message;
                }
                
                this.$bvToast.toast(errorMessage, {
                    title: "Error al cargar el PDF",
                    variant: "danger",
                    solid: true
                });
            } finally {
                this.isUploading = false;
            }
        },
        checkGuideUploadPermission() {
            // check if the user has the permission to upload PDF guides
            const companyPermissions = localStorage.getItem('empresa_permissions');
            if (companyPermissions && companyPermissions.includes('can_upload_guide_order')) {
                return this.user.isMaster === 1;
            }
            return false;
        },
        checkOwnOdooPermission() {
            const companyPermissions = localStorage.getItem('empresa_permissions');

            const hasActiveInstance = this.odooIstances.some(
                instance => instance.status === true
            );

            return (
                companyPermissions &&
                companyPermissions.includes('can_use_module_own_odoo') &&
                this.user.isMaster === 1 &&
                hasActiveInstance
            );
        },
        async sendOrderToOdooClient($odooInstanceId)
        {
            this.setLoading(true)
            this.isSendToOdooModalVisible = false;
            try {
                const response = await this.$conectar.post('odoo-client-order/send-order', { order_id: this.currentOrderId, odoo_id: $odooInstanceId });
                if (response.data.success === true) {
                        this.$bvToast.toast(response.data.message, {
                            title: "Pedido enviado a Odoo exitosamente",
                            variant: "success",
                            solid: true
                        });
                        
                    } else {
                        this.$bvToast.toast(response.data.message, {
                            title: "Error al enviar el pedido a Odoo",
                            variant: "danger",
                            solid: true
                        });
                    }
            } catch (e) {
                console.log(e.response);
                
                let errorMessage = "Parece que hubo un error al conectar con el servidor";
                
                if (e.response && e.response.data && e.response.data.message) {
                    errorMessage = e.response.data.message;
                }
                
                this.$bvToast.toast(errorMessage, {
                    title: "Error al enviar el pedido a Odoo",
                    variant: "danger",
                    solid: true
                });
            } finally {
                this.setLoading(false);
            }
        }
    }
}
</script>
<style scoped>
.widthPersonalized{
    max-width: 400px;
}
.precio{
    min-width: 600px;
}
.singleLine th {
  white-space: nowrap !important;
  overflow: hidden !important;
}

.singleLines {
  white-space: nowrap !important;
  overflow: hidden !important;
}
@media print {
  button {
    display: none;
  }
  #volver{
    display: none;
  }
}


</style>